import * as React from 'react';
import MaskedInput from 'react-text-mask';
import { Controller } from 'react-hook-form';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const baseComponentCss = css`

    input {
        display: block;
        width: 100%;
        height: calc(1.5em + 1.3rem + 2px);
        padding: .65rem 1rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #3f4254;
        background-color: #f5f8fa;
        background-clip: padding-box;
        border: 1px solid #f5f8fa;
        border-radius: .42rem;
        box-shadow: none;
        transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
		outline: 0;

        &:focus {
			outline: 0;
			background-color: #eef3f7;
			border-color: #eef3f7;
			
        }
        &:read-only {
			border: 0;
			background: none;
            cursor: not-allowed;
            background-color: #f5f8fa !important;
        }
    }


`;

const TextInput = React.forwardRef((props, ref) => {
	return <div css={baseComponentCss} className={props.className}>
		{props.mask ?
			<MaskedInput className={props.inputClassName} value={props.value ?? ""} type={props.type ? props.type : 'input'} readOnly={!!props.readOnly} name={props.name} placeholder={props.placeholder} ref={ref} mask={props.mask} onChange={props.onChange} onFocus={props.onFocus} onBlur={props.onBlur} /> :
			<input className={props.inputClassName} value={props.value ?? ""} type={props.type ? props.type : 'input'} readOnly={!!props.readOnly} placeholder={props.placeholder} ref={ref} onChange={props.onChange} onFocus={props.onFocus} onBlur={props.onBlur} onKeyDown={props.onKeyDown} max={props.max ?? ""} min={props.min ?? ""}/>
		}
	</div>
});

export default TextInput;